'use client'
import { decodeHTML } from 'entities'

import styles from './job-card.module.scss'

import type { JSX } from 'react'

type JobDescriptionProps = {
  description: string
}

export default function JobCardDescription({ description }: JobDescriptionProps): JSX.Element {
  return <p className={styles['job-card-description']}>{`${decodeHTML(description).substring(0, 120)}...`}</p>
}
